var map = {
	"./abb.svg": "39e6",
	"./eaton.svg": "5e22",
	"./fag.svg": "9472",
	"./hero-machine.png": "f93e",
	"./logo.svg": "9b19",
	"./pre-500.jpg": "3a92",
	"./schneider.svg": "75c7",
	"./sd-500.png": "fbf4",
	"./smc.svg": "cc57",
	"./smclogo.svg": "9b28",
	"./st-1500.png": "020f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";